import React from 'react';
import { useIntl } from 'react-intl';
import { SectionText } from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';

const Welcome = ({ name }) => {
  const intl = useIntl();
  return (
    <SectionText
      title={intl.formatMessage({ id: 'afforda.welcomePage.title' }, { name })}
      description={intl.formatMessage({
        id: 'afforda.welcomePage.description',
      })}
    />
  );
};

export default Welcome;
